<template>
    <BaseModal
        :id="'static-supervisor-modal'"
        :title="title"
        :size="''"
        :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="$emit('running_submit', {supervisor_report})">
                <div class="p-0 formdynamic__item col-md-12" :style="`margin-top:20px`">
                    <div  id="1">
                        <label style="display: block" v-html="`1. Which report version do you want to print?`" class="modal-label mb-3 " for="1"/>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="1yes"
                                :value="true"
                                v-model="supervisor_report"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text'" v-html="'Supervisor'"
                                for="1yes"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="1not"
                                :value="false"
                                v-model="supervisor_report"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'Employee'"
                                for="1not"
                            />
                        </div>
                    </div>
                </div> 
                <CentralLiteButtons save_text="Generate Report"/>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralLiteButtons   from    '@/components/CentralLiteButtons'

export default {

    name:   'SupervisorReportModal',
    props: [
        "title",
        "rest_api",
        "breadcrumb",
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            form_data:                  FormResources.form_data,
            form_format:                FormResources.form_format,
            form_backup:                {...FormResources.form_data},
            message: 'Choose the options that match your preferences.',
            supervisor_report: true
        }
    },

    methods:{
    },

    mounted(){
    }
    
}
</script>